import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store/store";
import { searchSelector, activeFilters, activeMobFilters } from "features/search-property/searchproperty.slice";
import useWindowSize from "hooks/useWindowSize";
import { clearSearchResult } from "features/search-result/searchresult.slice";

interface IAmenities {
    amenities: []
}
const Aminities: React.FC<IAmenities> = ({ amenities }) => {
    const dispatch = useAppDispatch();
    const size: any = useWindowSize();
    const [limit, setLimit] = useState(5);
    const { filters, mobFilters } = useAppSelector(searchSelector);
    const {t} = useTranslation();
    const updateAmenities = (e: any) => {

        if (e.target.classList.contains('inputc')) {
            const amenity = e.target.dataset.amenities;
            let params = (size?.width > 1110 ? { ...filters } : { ...mobFilters });
            if (params.amenities) {
                let addedamenities = params.amenities.split(',');
                if (e.target.classList.contains('inputc')) {
                    if (e.target.checked) {
                        addedamenities.push(amenity);
                    }
                    else {
                        addedamenities.splice(params.amenities.split(',').indexOf(amenity), 1);
                    }
                }
                params['amenities'] = addedamenities.join();
            }
            else {
                params['amenities'] = amenity;
            }

            if (size.width ? size.width > 1110 : false) {
                dispatch(clearSearchResult());
                dispatch(activeFilters(params));
            }
            else {
                dispatch(activeMobFilters(params));
            }
        }
    }
    return (
        <>
            {amenities?.length > 0}{
                <div>
                    {amenities?.map((item: any, index) => (index < limit &&
                        <label className="checkbox" key={index} onClick={(e) => { updateAmenities(e) }} data-amenities={item}>
                            <input 
                                type="checkbox" 
                                className="filter-checkbox inputc" 
                                onClick={(e) => { updateAmenities(e) }} 
                                data-amenities={item} 
                                defaultChecked={filters?.amenities?.includes(item)} 
                            />
                            {item}
                        </label>
                    ))}
                    {limit === 5 ? <label className="view-more-label" onClick={() => { setLimit(amenities.length) }} >{t("searchResults.more")}</label>
                        : <label className="view-more-label" onClick={() => { setLimit(5) }} >{t("searchResults.less")}</label>}
                </div>
            }
        </>
    );
};

export default Aminities;
